import { SortOrder } from '../../react-bootstrap-table-next/react-bootstrap-table2';

export class TableFilter {
    constructor(
        public filter: { filters: Array<any>; logic: string },
        public pageNumber: number,
        public pageSize: number,
        public sort: { dir: string; field: string }
    ) {}
}

export class TransactionTableFilter extends TableFilter {
    constructor(
        public filter: { filters: Array<any>; logic: string },
        public pageNumber: number,
        public pageSize: number,
        public sort: { dir: string; field: string },
        public selectedTransactionId: string | null
    ) {
        super(filter, pageNumber, pageSize, sort);
    }
}

export class TimelineDocumentsTableFilter extends TableFilter {
    constructor(
        public filter: { filters: Array<any>; logic: string },
        public pageNumber: number,
        public pageSize: number,
        public sort: { dir: SortOrder; field: string },
        public selectedDocumentId?: string
    ) {
        super(filter, pageNumber, pageSize, sort);
    }
}

export class PracticesTableFilter extends TableFilter {
    constructor(
        public filter: { filters: Array<any>; logic: string },
        public pageNumber: number,
        public pageSize: number,
        public sort: { dir: string; field: string }
    ) {
        super(filter, pageNumber, pageSize, sort);
    }
}
